import styled from '@emotion/styled';
import * as React from 'react';
import * as iconCloseWhite from '../../assets/icons/icon_close.svg';
import * as iconClose from '../../assets/icons/icon_close_gray.svg';

interface Props {
  onClose: (evt?: React.MouseEvent<HTMLElement>) => void;
  dataPendo?: string;
  iconSvg?: string;
  dataE2E?: string;
}

const CloseImg = styled('img')`
  cursor: pointer;
`;

export const CloseIcon = (props: Props) => {
  const { onClose, dataPendo, iconSvg, dataE2E } = props;
  return (
    <CloseImg
      onClick={onClose}
      data-pendo={dataPendo}
      src={iconSvg ? iconSvg : iconClose}
      data-e2e={dataE2E}
      alt="close"
    />
  );
};

export const ModalCloseIcon = (props: Props) => {
  const { onClose, dataPendo, iconSvg } = props;
  return (
    <CloseIcon
      onClose={onClose}
      dataPendo={dataPendo}
      iconSvg={iconSvg ? iconSvg : iconCloseWhite}
    />
  );
};

export default CloseIcon;
